import * as React from 'react';
import * as styles from './PackagesWithoutBetLayout.css';

export interface IPackagesWithoutBetLayoutProps {
  promotion: React.ReactNode;
  error: React.ReactNode;
}

export const PackagesWithoutBetLayout = ({ promotion, error }: IPackagesWithoutBetLayoutProps) => {
  return (
    <div>
      {promotion}
      <div className={styles['error']}>{error}</div>
    </div>
  );
};
